import { render, staticRenderFns, recyclableRender, components } from "./evaluate.vue?vue&type=template&id=2208e2a6&scoped=true&"
var renderjs
import script from "./evaluate.vue?vue&type=script&lang=js&"
export * from "./evaluate.vue?vue&type=script&lang=js&"
import style0 from "./evaluate.vue?vue&type=style&index=0&id=2208e2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208e2a6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/evaluate/evaluate.vue"
export default component.exports